import { ApolloQueryResult, gql } from '@apollo/client';
import { DocumentNode } from 'graphql';
import invariant from 'invariant';

import { getApolloClientSingleton } from 'lib/apollo/client/browser';

import apiRequest from './apiRequest';

export default class RemindAPI {
  static request(
    endpoint: string,
    method: string = 'GET',
    data: Object = {},
    isJSON: boolean = true
  ): Promise<any> {
    return apiRequest(endpoint, method, data, isJSON);
  }

  /**
   * @deprecated
   *
   * ATTENTION DO NOT USE
   * This method has been marked deprecated, you should
   * use apollo react wrappers like the Query and Mutation components
   * or, whenever we upgrade to apollo 3, apollo hooks (best option).
   *
   * This is here for historical reasons but there is no longer any reason
   * to keep using it, 99.9% of the times what you should be using is what
   * is suggested above, for the 0.1% where you need a pure imperative
   * apollo interactions you should use the apollo client directly.
   *
   *
   */
  static execute<T, V = { [key: string]: any }>(args: {
    query?: DocumentNode;
    mutation?: DocumentNode;
    variables?: V;
    forceFetch?: boolean;
    refetchQueries?: { query: DocumentNode; variables?: Object }[];
  }): Promise<T> {
    console.warn(
      'DEPRECATED please migrate to Query / Mutation or hooks',
      args.query,
      args.mutation
    );
    const { query, mutation, variables, forceFetch, refetchQueries } = args;
    invariant(query || mutation, 'GraphQL queries must include either a query or mutation');
    const apollo = getApolloClientSingleton();

    let promise = null;
    const variablesOrDefault = variables || {};
    const forceFetchOrDefault = forceFetch || false;

    if (query) {
      const options = {
        variables: variablesOrDefault,
        fetchPolicy: forceFetchOrDefault ? 'network-only' : 'cache-first',
      };
      // @ts-expect-error ts-migrate(2345) FIXME: Argument of type '{ variables: {}; fetchPolicy: st... Remove this comment to see the full error message
      promise = apollo.query<T>(Object.assign({}, options, { query }));
    } else {
      const options = refetchQueries
        ? { variables: variablesOrDefault, refetchQueries }
        : { variables: variablesOrDefault };
      promise = apollo.mutate<T>(
        Object.assign({}, options, { mutation } as { mutation: DocumentNode })
      );
    }

    return (promise as Promise<ApolloQueryResult<T>>).then((response: ApolloQueryResult<T>) => {
      if (response.errors) {
        console.error(response.errors);
      }
      return response.data;
    });
  }

  static registerWatchQuery(args: {
    query: DocumentNode;
    variables?: any;
    onQueryChange: (data: Object) => void;
  }): void {
    const { query, variables, onQueryChange } = args;
    const variablesOrDefault = variables || {};

    function next(results: ApolloQueryResult<any>) {
      if (results.loading === false) {
        onQueryChange(results.data);
      }
    }

    const options = { query, variables: variablesOrDefault };
    const queryObserver = getApolloClientSingleton().watchQuery(options);
    queryObserver.subscribe({ next });
  }
}

export const ERRORS = {
  birthdate_required: 'birthdate_required',
  not_found: 'not_found',
  cannot_respond_to_closed_event: 'cannot_respond_to_closed_event',
};

// @ts-expect-error ts-migrate(2304) FIXME: Cannot find name '__DEV__'.
if (__DEV__ && typeof window !== 'undefined') {
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'gql' does not exist on type 'Window & ty... Remove this comment to see the full error message
  window.gql = gql;
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'RemindAPI' does not exist on type 'Windo... Remove this comment to see the full error message
  window.RemindAPI = RemindAPI;
}
